import FOCUSONE_LOADING from '../assets/gifs/f1_loading.gif';

export default { FOCUSONE_LOADING };
